import types from "../types"

/* Update */
export default function update(model, id, data) {
  return {
    type: types.update,
    model,
    id,
    data,
  }
}

update.success = function updateSuccess(model, id, data) {
  return {
    type: types.updateSuccess,
    model,
    id,
    data,
  }
}

update.error = function updateError(model, id, error) {
  return {
    type: types.updateError,
    model,
    id,
    error,
  }
}

update.cancel = function updateCancel(model, id, reason = `No reason`) {
  return {
    type: types.createError,
    model,
    id,
    reason,
  }
}
